import {PaymentMethod} from '../paymentMethod';

export function toString(this: PaymentMethod) {
    return `Deal: ${this.id}`;
}
